import { useState } from 'react';
import { fetchProducts } from '../../api/product';
import { Product } from '../../types/product';
import ProductPickerModal from '../product/ProductPickerModal';

interface ContractProductCellProps {
  productId?: number | null;
  productName: string;
  onSelectProduct: (product: Product) => void;
  onClear: () => void;
  products: Product[];
  onProductsUpdated: (products: Product[]) => void;
}

function productSummary(productId: number | null | undefined, productName: string) {
  if (!productName.trim() && productId == null) return '';
  return productName.trim() || (productId != null ? `제품 ${productId}` : '');
}

function ContractProductCell({
  productId,
  productName,
  onSelectProduct,
  onClear,
  products,
  onProductsUpdated,
}: ContractProductCellProps) {
  const [pickerOpen, setPickerOpen] = useState(false);
  const summary = productSummary(productId, productName);

  return (
    <div className="contract-product-cell">
      <div className="contract-product-cell__row">
        <button
          type="button"
          className={`contract-product-cell__pick${summary ? ' has-value' : ''}`}
          onClick={() => setPickerOpen(true)}
        >
          {summary || '제품 선택'}
        </button>
        {summary ? (
          <button
            type="button"
            className="contract-product-cell__clear"
            title="선택 해제"
            onClick={onClear}
          >
            지우기
          </button>
        ) : null}
      </div>

      <ProductPickerModal
        open={pickerOpen}
        products={products}
        title="계약 제품 선택"
        onClose={() => setPickerOpen(false)}
        onListsUpdated={onProductsUpdated}
        onSelect={onSelectProduct}
      />
    </div>
  );
}

export async function loadContractProducts(): Promise<Product[]> {
  return fetchProducts();
}

export default ContractProductCell;
